import React from "react";
import { motion } from "framer-motion";
import { Coffee, Flame, Heart } from "lucide-react";

const features = [
  {
    icon: Coffee,
    title: "Hecho al momento",
    text: "Cada waffle se prepara cuando lo pides. Sin congeladores, sin atajos.",
  },
  {
    icon: Flame,
    title: "Crujiente perfecto",
    text: "Receta belga con masa fermentada, dorado por fuera, suavecito por dentro.",
  },
  {
    icon: Heart,
    title: "Ingredientes top",
    text: "Frutas frescas, Oreo, Milo, queso fundido, tocino crujiente. Sin compromisos.",
  },
];

export const Story = () => {
  return (
    <section
      id="historia"
      data-testid="story-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 rounded-full bg-[#FDF8E1] border border-[#3E2723]/10 px-4 py-2 text-xs font-bold tracking-widest uppercase text-[#3E2723]/80 mb-5"
          >
            Nuestra historia
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-display font-black tracking-tight text-[#3E2723] leading-[0.95]"
            style={{ fontSize: "clamp(2.2rem, 5vw, 4rem)" }}
          >
            Donde el waffle se vuelve{" "}
            <span className="italic text-[#D38C41]">obra de arte</span>.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-5 text-[#5D4037] text-base md:text-lg leading-relaxed font-body max-w-xl"
          >
            En <span className="font-bold text-[#3E2723]">Buffy&rsquo;s</span>{" "}
            mezclamos la tradición del waffle belga con los sabores que más nos
            gustan: dulces decadentes, combinaciones saladas y mucha creatividad
            sobre el plato. Cada receta nace para sorprenderte.
          </motion.p>
        </div>

        <div className="lg:col-span-6 grid sm:grid-cols-1 gap-4">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              className="flex items-start gap-5 bg-[#FFFDF9] rounded-[2rem] p-6 md:p-7 border border-[#3E2723]/5 shadow-[0_15px_35px_rgba(62,39,35,0.05)]"
              data-testid={`story-feat-${i}`}
            >
              <div className="shrink-0 w-14 h-14 rounded-2xl bg-[#3E2723] text-[#FDF8E1] grid place-items-center">
                <f.icon size={22} />
              </div>
              <div>
                <h3 className="font-display font-extrabold text-xl text-[#3E2723] mb-1">
                  {f.title}
                </h3>
                <p className="text-sm text-[#5D4037] font-body leading-relaxed">
                  {f.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Story;
